import { render, staticRenderFns } from "./Act.vue?vue&type=template&id=aee4b0ba&scoped=true"
import script from "./Act.vue?vue&type=script&lang=js"
export * from "./Act.vue?vue&type=script&lang=js"
import style0 from "./Act.vue?vue&type=style&index=0&id=aee4b0ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aee4b0ba",
  null
  
)

export default component.exports